<template>
  <div class="zyc-tags">
    <el-tag :key="v.title"
            v-for="(v,index) in data"
            closable
            :disable-transitions="false"
            @close="handleClose(v,index)">
      {{v.title}}
    </el-tag>
    <label @click="emptyAll">清空</label>
    <div style="clear:both;"></div>
  </div>
</template>
<script>
  
  /**
  * tags 组件
  */
  export default {
    name: 'zycTags',
    props: {
      data: {
        type: Array,
        default: () => []
      },
      tagsChange: {
        type: Function,
        default: () => { }
      }
    },
    model: {
      prop: 'data'
    },
    watch: {
    },
    data() {
      return {
      }
    },
    mounted() {

    },
    created() {
    },
    methods: {
      handleClose(v,i) {
        this.data.splice(i, 1)
        this.tagsChange(this.data, 'close', v, i)
      },
      emptyAll: function () {
        this.data.splice(0, this.data.length);
        this.tagsChange(this.data, 'empty')
      },
      addItem: function (val) {
        this.data.push(val)
        this.tagsChange(this.data, 'add', val)
      },
      removeTypeAll: function (t) {
        this.data.forEach((el,i) => {
          if (el.type == t) {
            this.data.splice(i, 1)
          }
        })
      },
      removeTypeAndLv: function (t, lv) {
        this.data.forEach((el, i) => {
          if (el.type == t && el.lv == lv) {
            this.data.splice(i, 1)
          }
        })
      },
      removeTitle: function (t) {
        this.data.forEach((el, i) => {
          if (el.title == t) {
            this.data.splice(i, 1)
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/other/tags.vue